<template>
  <div class="infinite-scroll-wrapper">
    <slot />
    <div
      v-if="loading"
      class="infinite-scroll-loading"
    >
      <slot name="loading">
        <van-loading size="24px" color="#409bff"/>
        <span class="loading-text">{{ loadingText }}</span>
      </slot>
    </div>
    <div class="infinite-scroll-finished" v-if="finished && !loading">
      <slot name="finished">
          <span>{{ finishedText }}</span>
      </slot>
    </div>
  </div>
</template>

<script>
import utils from '@/utils/scroll'
// import { on, off } from '@/utils/dom'
import dom from '@/utils/dom'
const COMPONENT_NAME = 'jc-infinite-scroll'
export default {
  name: COMPONENT_NAME,
  model: {
    prop: 'loading'
  },
  props: {
    loading: Boolean,
    finished: Boolean,
    immediateCheck: {
      type: Boolean,
      default: true
    },
    offset: {
      type: Number,
      default: 0
    },
    loadingText: {
      type: String,
      default: '加载中...'
    },
    finishedText: {
      type: String,
      default: '加载完毕...'
    }
  },
  data () {
    return {
      scroller: null
    }
  },
  watch: {
    loading () {
      this.$nextTick(this.check)
    },
    finished () {
      // this.$nextTick(this.check)
    }
  },
  mounted () {
    this.scroller = utils.getScrollEventTarget(this.$el)
    this.handler(true)
    if (this.immediateCheck) {
      this.$nextTick(this.check)
    }
  },
  destroyed () {
    this.handler(false)
  },
  activated () {
    this.handler(true)
  },
  deactivated () {
    this.handler(false)
  },
  methods: {
    check (e) {
      if (this.loading || this.finished) {
        return
      }
      const el = this.$el
      const { scroller } = this
      const scrollerHeight = utils.getVisibleHeight(scroller)
      /* istanbul ignore next */
      if (!scrollerHeight || utils.getComputedStyle(el).display === 'none' || el.offsetParent === null) {
        return
      }
      const scrollTop = utils.getScrollTop(scroller)
      const targetBottom = scrollTop + scrollerHeight
      let reachBottom = false
      /* istanbul ignore next */
      if (el === scroller) {
        reachBottom = scroller.scrollHeight - targetBottom < this.offset
      } else {
        const elBottom =
          utils.getElementTop(el) -
          utils.getElementTop(scroller) +
          utils.getVisibleHeight(el)
        reachBottom = elBottom - scrollerHeight < this.offset
      }
      // console.log(e)
      /* istanbul ignore else */
      if (reachBottom) {
        // this.$emit('input', true)
        this.$emit('load')
      }
    },
    handler (bind) {
      /* istanbul ignore else */
      if (this.binded !== bind) {
        this.binded = bind
        bind ? dom.on(this.scroller, 'scroll', this.check) : dom.off(this.scroller, 'scroll', this.check)
        // window.addEventListener('scroll', () => {
        //   this.check()
        // })
      }
    }
  }
}
</script>

<style lang="scss">
.infinite-scroll-loading {
  text-align: center;
  font-size: 30px;
  padding: 5px;
  .van-loading {
    display: inline-block;
  }
}
.infinite-scroll-finished {
  text-align: center;
  color: #bbb;
  line-height: 60px;
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/infinite-scroll/index.vue